import { useState } from 'react';

function usePagination(data, itemsPerPage) {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.max(1, Math.ceil(data.length / itemsPerPage));
  // currentPage can be left pointing past the end once data shrinks (a
  // filter narrows results, a refresh returns fewer rows, ...) without any
  // next/prev/jump call to re-clamp it — derive the effective page the same
  // way rather than letting currentData() slice against a stale, oversized
  // page and silently return [].
  const effectiveCurrentPage = Math.min(currentPage, maxPage);

  function currentData() {
    const begin = (effectiveCurrentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  }

  function next() {
    setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
  }

  function prev() {
    // Clamp to maxPage first — otherwise a stale, post-shrink currentPage
    // (e.g. 5 when maxPage just dropped to 2) computes currentPage - 1 from
    // the stale value, so the exposed effectiveCurrentPage (already clamped
    // to 2) doesn't visibly move until enough clicks walk the internal state
    // back down into range.
    setCurrentPage((currentPage) => Math.max(Math.min(currentPage, maxPage) - 1, 1));
  }

  function jump(page) {
    const pageNumber = Math.max(1, page);
    setCurrentPage(() => Math.min(pageNumber, maxPage));
  }

  return { next, prev, jump, currentData, currentPage: effectiveCurrentPage, maxPage };
}

export default usePagination;
